import styled, { css } from 'styled-components';

const CityCircle = styled.div`
  box-sizing: content-box;
  position: absolute;
  border-radius: 50%;
  transition-property: width, height, background;
  transition-duration: 400ms;
  transition-timing-function: ease-out;
  transform: translate(-50%, -50%);

  /* XXX: outline fixes jagged circle edges in Chrome
   * due to transform, which is needed to position circles above cities
   * https://stackoverflow.com/questions/6492027/css-transform-jagged-edges-in-chrome
   */
  outline: 1px solid transparent;
  cursor: pointer;

  ${({ selected }) =>
    selected
      ? css`
          border: 1px solid ${({ theme }) => theme.colors.white};
          box-shadow: 4px 2px 2px rgba(0, 0, 0, 0.25);
          z-index: 10;
        `
      : null};
`;

CityCircle.displayName = 'MapCircle';

export default CityCircle;



// WEBPACK FOOTER //
// ./src/components/MapPage/CityCircle.jsx